import React, {useCallback, useEffect, useRef, useState} from "react";
import {useTheme} from "../contexts/theme";
import "./Mam.css";
import PageContainer from "../components/CommonComponents/PageContainer/PageContainer";
import {AccordionSummary, Box, CssBaseline, Typography} from "@mui/material";
import {defaultFadeDuration, SportImagesDict} from '../utils/constants'
import {LoadError, SupportedSports} from "../types/generic";
import {Filters} from "../types/filterTypes";
import {Clip, HierarchyFootball, MamSummaryPageState, SearchOptions} from "../types/mamTypes";
import CompetitionContainer from "../components/MamContent/CompetitionContainer";
import {useMamSummary} from "../contexts/mamSummary";
import {useMamInformation} from "../contexts/MamInformation";
import StyledIconButton from "../components/CommonComponents/StyledIconButton/StyledIconButton";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import StyledDrawerComponent from "../components/CommonComponents/StyledDrawerComponent/StyledDrawerComponent";
import Filter from "../components/MamContent/MamFilterComponent/Filter";
import {DateRange} from "@mui/x-date-pickers-pro/models";
import {Dayjs} from "dayjs";
import {ActiveFilters, useActiveFilters} from "../contexts/activeFilters";
import DraggableListComponent from "../components/CommonComponents/DragAndDropComponent/DraggableListComponent";
import {useClipMamSelected} from "../contexts/clipMamSelected";
import MamOptions from "../components/MamContent/MamOptions/MamOptions";
import {
    createPhysicalHighlight,
    deleteClipPlatform,
    getFiltersOptions,
    loadAssets,
    performFilterOptions,
    getTabularClips, getAspectRatios
} from "../queries/mamPageQueries";
import ErrorSnackBar from "../components/CommonComponents/ErrorSnackBar/ErrorSnackBar";
import MamTableV2 from "../components/MamContent/MamTableComponent/MamTableV2";
import _ from "lodash";
import axios from "axios";
import SpinnerBox from "../components/CommonComponents/SpinnerBox/SpinnerBox";
import OpenerCloserComponent, {
    Competition, defaultCompetition
} from "../components/CommonComponents/OpenerCloserComponent/OpenerCloserComponent";
import {
    defaultOpenerCloserObject,
} from "../components/CommonComponents/OpenerCloserComponent/OpenerCloserContentComponent";
import Accordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import {fadeDurationStep, maxAudioFadeDuration, minAudioFadeDuration} from "../utils/constants";
import AudioFadingCollapse from "../components/CommonComponents/AudioFadingCollapse/AudioFadingCollapse";
import {markEditedGroupClips, sortByCustomOrderThenDate} from "../utils/utilsClip";
import {getUniqueCompetitions, areSelectedItemsMultiEvent} from "../utils/utils";
import {OpenerCloserObject} from "../types/opernerCloserTypes";
import ClipAggregatePopup from "../components/ClipAggregatePopup/ClipAggregatePopup";
import {useSSEProvider} from "../contexts/SSEProvider";
import {jobSSE} from "../types/jobDataTypes";

const tabularPageSize = 15;


const Mam = () => {

    const { jobsRunning, openSSE } = useSSEProvider();
    const runningJobsRef = useRef<jobSSE[]>([])

    const [filterValues, setFilterValues] = useState<Filters | undefined>();
    const [autoCompleteTextValues, setAutoCompleteTextValues] = useState<Record<string, string>>({});
    const [firstLoading, setFirstLoading] = useState(true);
    const [isFirstLoading, setIsFirstLoading] = useState(true);
    const [dataHierarchy, setDataHierarchy] = useState<HierarchyFootball>();
    const [textSearch, setTextSearch] = useState<string>("")
    const [loadMamDataError, setLoadMamDataError] = useState<LoadError>({
        error: false,
        message: "",
    });

    const theme = useTheme();

    const [includeFilters, setIncludeFilters] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
    const [competitions, setCompetitions] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<{error: boolean, message: string}>({
        error:false,
        message: "",
    })
    const [firstLoadingOfMam, setFirstLoadingOfMam] = useState(true);
    const [selectView, setSelectView] = useState<("cards" | "table")>("cards");


    const {activeFilters, searchOptions} = useActiveFilters();
    const {setActiveFilters, setSearchOption} = useActiveFilters();

    const {clips, addClips, deleteSpecificClips, deleteAllClips, setClipState, setAspectRatio, aspectRatio} = useClipMamSelected();

    const {information} = useMamInformation();
    const {setInformation} = useMamInformation();
    const {setCompetition} = useMamInformation();
    const {setMatchDay} = useMamInformation();
    const {setMatchDayEvents} = useMamInformation();
    const {setClipGroups} = useMamInformation();
    const {setClip} = useMamInformation();
    const {setSummary} = useMamSummary();
    const {summary} = useMamSummary();
    const isFirstCall = useRef(true); // Flag per capire se è la prima chiamata
    const latestSummary = useRef(summary); //Se mi serve solo qua, altrimenti inserirla nel contesto
    const latestActiveFilter = useRef(activeFilters);
    const firstLoadingRef = useRef(true);
    const autoCompleteTextValuesRef = useRef<Record<string, string>>()
    const abortControllerRef = useRef<AbortController | null>(null);
    const abortControllerGetDataRef = useRef<AbortController | null>(null);
    const abortControllerTabularDataRef = useRef<AbortController | null>(null);
    const {deleteLoading, setDeleteLoading} = useMamInformation()
    const deleteLoadingRef = useRef<boolean>(false);
    const {updateLoading: updateLoading} = useMamInformation();
    const updateRatingLoadingRef = useRef<boolean>(false);
    const getDataLoadingRef = useRef<boolean>(false);
    const getTableLoadingRef = useRef<boolean>(false);
    const tablePageLoadingRef = useRef<boolean>(false);

    const [tabularData, setTabularData] = useState<Clip[]>([])
    const [page, setPage] = useState(0);
    const [tableLoading, setTableLoading] = useState<boolean>(false)
    const tablePageRef = useRef<number>(0)
    const [loading, setLoading] = useState<boolean>(false)
    const [filterLoading, setFilterLoading] = useState<boolean>(false)

    const {pagesSummary} = useMamSummary()
    const pagesSummaryRef = useRef<MamSummaryPageState>()

    // opener-closer
    const [selectedOpener, setSelectedOpener] = useState<OpenerCloserObject>(defaultOpenerCloserObject);
    const [selectedCloser, setSelectedCloser] = useState<OpenerCloserObject>(defaultOpenerCloserObject);
    const [uniqueCompetitions, setUniqueCompetitions] = useState<Competition[]>([{id: undefined, name: "", type: "", season: ""}]);
    const [areMultiEvent, setAreMultiEvent] = useState<boolean>(false);

    const [audioFading, setAudioFading] = useState<boolean>(false)
    const [audioFadingDuration, setAudioFadingDuration] = useState<number>(defaultFadeDuration)
    const [highlightAspectRatioOption, setHighlightAspectRatioOption] = useState<string[]>([])
    const [selectedCompetition, setSelectedCompetition] = useState<Competition>({ id: undefined, name: "", type: "", season: "" })
    const [openCreateAggregate, setOpenCreateAggregate] = useState<boolean>(false);


    useEffect(() => {
        if(clips.length === 0) {
            setSelectedOpener(defaultOpenerCloserObject);
            setSelectedCloser(defaultOpenerCloserObject)
        }
    }, [clips]);

    useEffect(() => {
        pagesSummaryRef.current = pagesSummary
        if (abortControllerGetDataRef.current){
            abortControllerGetDataRef.current.abort();
            getDataLoadingRef.current = false;
        }
    }, [pagesSummary]);

    useEffect(() => {
        autoCompleteTextValuesRef.current = autoCompleteTextValues
    }, [autoCompleteTextValues]);
    const selectViewRef = useRef(selectView);

    useEffect(() => {
        updateRatingLoadingRef.current = updateLoading;
    }, [updateLoading]);

    useEffect(() => {
        if(updateLoading && abortControllerGetDataRef.current) {
            abortControllerGetDataRef.current.abort();
            getDataLoadingRef.current = false;
        }
    }, [updateLoading]);

    useEffect(() => {
        deleteLoadingRef.current = deleteLoading;
    }, [deleteLoading]);

    useEffect(() => {
        if (deleteLoading && abortControllerGetDataRef.current){
            abortControllerGetDataRef.current.abort();
            getDataLoadingRef.current = false;

        }
        if (deleteLoading && abortControllerTabularDataRef.current){
            abortControllerTabularDataRef.current.abort();

        }
    }, [deleteLoading]);

    useEffect(() => {
        runningJobsRef.current = jobsRunning
        if(information?.clipGroups){
            const editMarkGroupClips = markEditedGroupClips(runningJobsRef.current, information.clipGroups)
            if (editMarkGroupClips.change) {
                setInformation({...information, clipGroups:editMarkGroupClips.clipGroups})
            }
        }
    }, [jobsRunning]);

    useEffect(() => {
        openSSE()
    }, []);

    const debouncedGetData = useCallback(
        _.debounce((isSummaryChanged: boolean) => getData(isSummaryChanged), 500),
        []
    );

    const debouncedGetTabularClips = useCallback(
        _.debounce(() => getTabularClipsWithLoading(), 500),
        []
    );

    async function getTabularClipsWithLoading(changePage?: boolean){
        try{
            if (abortControllerTabularDataRef.current) {
                abortControllerTabularDataRef.current.abort();
            }

            abortControllerTabularDataRef.current = new AbortController();

            setTableLoading(true)
            getTableLoadingRef.current = true;
            if(changePage){
                tablePageLoadingRef.current = true;
            }
            setTabularData(await getTabularClips(tabularPageSize, tablePageRef.current, latestActiveFilter.current, abortControllerTabularDataRef.current))
            setTableLoading(false)
            getTableLoadingRef.current = false;
            if(changePage){
                tablePageLoadingRef.current = false;
            }
        }catch(error){
            if (!axios.isCancel(error)){
                console.error("Error to find get data for ", error)
                getTableLoadingRef.current = false;
                if(changePage){
                    tablePageLoadingRef.current = false;
                }
                setTableLoading(false)
            }
        }
    }


    async function getFilteredOptions(field: string, value:string, abortController: AbortController | null){
        try{
            const newFilterOptions = await performFilterOptions(field, value, abortController)
            if (filterValues && (field === 'jobFilterValues' || field === 'matchFilterValues') && filterValues[field]){
                const tempFilterValues: Filters= {...filterValues}
                tempFilterValues[field].options = newFilterOptions
                setFilterValues(tempFilterValues);
            }
        }catch (error){
            if (!axios.isCancel(error)){
                console.error("Error to find new Options for " + field, error)
            }
        }
    }

    const debouncedGetFilteredOptions = _.debounce((field:string, value: string, abortController: AbortController | null) => getFilteredOptions(field, value, abortController), 500)

    async function onAutoCompleteTextChange(field: keyof ActiveFilters, value: string) {
        const tempTextFilterValues = {...autoCompleteTextValues}
        tempTextFilterValues[field] = value;
        setAutoCompleteTextValues(tempTextFilterValues)

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();

        if (field === "jobFilterValues" || field === "matchFilterValues"){
            debouncedGetFilteredOptions(field, value, abortControllerRef.current);
        }
    }



    const getData = async (isSummaryChanged?: boolean) => {

        isFirstCall.current ?  setLoading(true) : setLoading(false);
        try {

            if (abortControllerGetDataRef.current && !isFirstCall.current && isSummaryChanged) {
                abortControllerGetDataRef.current.abort();
            }

            abortControllerGetDataRef.current = new AbortController();

            const sortOrder = {
                "16:9": 0,
                "9:16": 1,
                "4:5": 2,
                "1:1": 3
            };

            if(isSummaryChanged) {
                setFilterLoading(true)
            }

            getDataLoadingRef.current = true;
            loadAssets(latestSummary.current, pagesSummaryRef.current, latestActiveFilter.current, abortControllerGetDataRef.current)
                .then(assets => {
                    getDataLoadingRef.current = false;
                    if (assets) {
                        setLoading(false);
                        setFilterLoading(false);
                    }

                    /*console.log("FILTRI", assets.valuesFilters)
                    console.log("PROVA GERARCHIA", assets.prova);
                    console.log("Gerarchia piatta", assets.hierarchy);*/


                    let clipsOrder;

                    if (assets.hierarchy.clips !== undefined) {
                        clipsOrder = sortByCustomOrderThenDate(assets.hierarchy.clips,
                            'aspect_ratio',
                            'generate_at',
                            sortOrder,
                            'desc' )
                    }


                    const markedClipGroups = markEditedGroupClips(runningJobsRef.current, assets.hierarchy.clipGroups || [])

                    if (isFirstCall.current) {
                        setInformation({
                            competitions: assets.hierarchy.competitions,
                            matchDay: assets.hierarchy.matchdays,
                            matchDayEvents: assets.hierarchy.events,
                            clipGroups: markedClipGroups.clipGroups,
                            clip: clipsOrder !== undefined ? clipsOrder : [] ,
                        });


                        const tempSummary = {...summary};
                        tempSummary.competition = assets.hierarchy.competitions[0].id;
                        setSummary(tempSummary);
                        setCompetitions(assets.hierarchy.competitions[0].id);

                        isFirstCall.current = false; // Disattivo il flag dopo la prima esecuzione

                    }else{
                        setInformation({
                            competitions: assets.hierarchy.competitions.map((comp: Competition) => {
                                if (comp.season != null && !isNaN(parseInt(comp.season))) {
                                    return { ...comp, name: `${comp.name} - ${comp.season}` };
                                }

                                return comp;
                            }),
                            matchDay: assets.hierarchy.matchdays,
                            matchDayEvents: assets.hierarchy.events,
                            clipGroups: markedClipGroups.clipGroups,
                            clip: clipsOrder !== undefined ? clipsOrder : [],
                        });
                    }

                }).catch(error => {
                    if (!axios.isCancel(error)){
                        getDataLoadingRef.current = false;
                        setFilterLoading(false)
                        console.error("Error to find get data for ", error)
                    }
                })
            const searchOptions: SearchOptions = {}
            if (autoCompleteTextValuesRef.current && autoCompleteTextValuesRef.current.matchFilterValues){
                searchOptions.matchFilterValues = autoCompleteTextValuesRef.current.matchFilterValues;
            }
            if (autoCompleteTextValuesRef.current && autoCompleteTextValuesRef.current.jobFilterValues){
                searchOptions.jobFilterValues = autoCompleteTextValuesRef.current.jobFilterValues;
            }
            getFiltersOptions(searchOptions, abortControllerGetDataRef.current).then(tempFilterValues => {
                setFilterValues(tempFilterValues);
                if (firstLoadingRef.current){
                    const tempTextFilterValues: Record<string, string> = {}
                    for (const filterField in tempFilterValues){
                        tempTextFilterValues[filterField] = "";
                    }
                    firstLoadingRef.current = false;
                    setAutoCompleteTextValues(tempTextFilterValues);
                }
            }).catch(error => {
                if (!axios.isCancel(error)){
                    console.error("Error to find get data for ", error)
                }
            })

            //console.log("GETDATA", response.data);
        } catch (errorData) {
            console.error("Error during polling", errorData);
        }

    };


    useEffect(() => {
        latestActiveFilter.current = activeFilters;
        if (selectViewRef.current === 'cards') {
            activeFilters.lastTypeModified === 'text' ? debouncedGetData(true) : getData(true); // Prima chiamata immediata
        }else{
            activeFilters.lastTypeModified === 'text' ? debouncedGetTabularClips() : getTabularClipsWithLoading();
        }


    }, [activeFilters]);

    useEffect(() => {
        selectViewRef.current = selectView;
        if(selectView === 'table'){
            if (page === 0){
                getTabularClipsWithLoading() ;
            }else{
                setPage(0);
            }
        }else{
            getData();
        }
    }, [selectView]);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        const startPolling = () => {
            interval = setInterval(() => {
                if (selectViewRef.current === 'cards' && !deleteLoadingRef.current && !updateRatingLoadingRef.current && !getDataLoadingRef.current) {
                    getData();
                }
                else if (selectViewRef.current === 'table' && !deleteLoadingRef.current && !getTableLoadingRef.current && !tablePageLoadingRef.current){
                    getTabularClipsForTable();
                }
            }, 10000);
        };

        startPolling();

        getAspectRatios().then(aspectRatios => setHighlightAspectRatioOption(aspectRatios));

        return () => {
            if (interval) {
                clearInterval(interval); // Pulizia quando il componente si smonta
            }
            setActiveFilters({fastClipFilter: true})
            setInformation({
                competitions: [],
                matchDay: [],
                matchDayEvents: [],
                clipGroups: [],
                clip: [],
            });

            setSummary({
                competition: "",
                match: [],
                groupClip: [],
                entityName: "",
                matchDay: [],
            })

            setClipState([]);
        };
    }, []);



/*
    useEffect(() => {
        console.log("INFORMAZIONI", information);
        console.log("SUMMARY", summary);
    }, [information]); */

    useEffect(() => {
        latestSummary.current  = summary;
    }, [summary]);

    const handleActiveFilter = (name: keyof ActiveFilters, value: string | DateRange<Dayjs> | any, type = '') => {
        const tempActiveFilters = {...activeFilters}
        tempActiveFilters[name] = value;
        tempActiveFilters.lastTypeModified = type;
        setActiveFilters(tempActiveFilters);
    }

    const handleCompetiton = (competition: string) => {
        setCompetitions(competition);
    }

    const handleCreateHighlight = async () => {
        const body: any = { clips: [] as Array<{ id: string }> };
        if (clips.length > 0) {
            clips.forEach((clipItem: any) => {
                if (clipItem.id) {
                    if (!body.clips.includes(clipItem.id)) {
                        body.clips.push({id: clipItem.id});
                    }
                }
            });
            if(selectedOpener) {
                body.opener_config = selectedOpener.id !== "" ? selectedOpener.id : null
            }
            if(selectedCloser) {
                body.closer_config = selectedCloser.id !== "" ? selectedCloser.id : null
            }

            if (audioFading){
                body.fade = audioFading
            }
            if (audioFadingDuration){
                body.fade_duration = audioFadingDuration
            }
            try {
                setErrorMessage({error: true, message: 'Current highlight creation...'});
                const response = await createPhysicalHighlight(body, true);
                if (response) {
                    setErrorMessage({error: true, message: 'Highlight successfully created. '});
                }
            } catch (error) {
                console.error("Failed to create highlight: ", error);
                setErrorMessage({error: true, message: 'Failed highlight creation. '});
            }
        }else{
            setErrorMessage({error: true, message: 'No clip'});
        }
    };

    const handleDeselectClip = () => {
        deleteAllClips();
        setAspectRatio("16:9")
    }

    const handleDeleteClip = async () =>
    {
        try{
            setDeleteLoading(true);
            deleteAllClips();
            const deletePromises = clips.map((item, index)=> deleteClipPlatform(item.id))
            await Promise.all(deletePromises);
        }finally {
            setDeleteLoading(false);
        }


    }

    const handleOpenPopupAggregates = () => {
        setOpenCreateAggregate(true);
    }

    const handleChangeView = (view: "cards" | "table") => {
        setSelectView(view);
    }

    const drawerWidth = 300; // Larghezza draw

    const handleModifyClip = (name: string) => {}


    const getTabularClipsForTable = async () => {
        try{
            getTableLoadingRef.current = true;
            if (abortControllerTabularDataRef.current) {
                abortControllerTabularDataRef.current.abort();
            }

            abortControllerTabularDataRef.current = new AbortController();

            setTabularData(await getTabularClips(tabularPageSize, tablePageRef.current, latestActiveFilter.current, abortControllerTabularDataRef.current))
            getTableLoadingRef.current = false;
        }catch(error){
            if (!axios.isCancel(error)){
                console.error("Error to find get data for ", error)
                getTableLoadingRef.current = false;
            }
        }
    }

    useEffect(() => {
        const changePage = async () => {
            if(selectView === 'table'){
                tablePageRef.current = page
                await getTabularClipsWithLoading(true)
            }
        }
        changePage()
    }, [page]);

    const handlePage = (page: number) => {
        setPage(page);
    }

    const handleErrorMessage = (error: boolean, message: string) => {
        setErrorMessage({
            error: error,
            message: message
        })
    }

    useEffect(() => {
        if(clips.length > 0) {
            setUniqueCompetitions(getUniqueCompetitions(clips));
            setAreMultiEvent(areSelectedItemsMultiEvent(clips));
        } else {
            setUniqueCompetitions([defaultCompetition])
            setAreMultiEvent(false)
        }
    }, [clips]);

    useEffect(() => {
        if(uniqueCompetitions.length > 0) {
            setSelectedCompetition({name: uniqueCompetitions[0].name, id: uniqueCompetitions[0].id, type: "", season: ""});
        }
    }, [uniqueCompetitions, areMultiEvent]);

    return (

        <PageContainer>



            <ErrorSnackBar  autoHideDuration={2000} open={errorMessage.error} setClose={()=>{setErrorMessage({
                error: false,
                message: ""
            })}} errorMessage={errorMessage.message} />

            <Box
                style={{
                    width: "100%",
                    height: "100%",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    backgroundColor: theme.palette.blue,

                }}
            >
                <Box style={{
                    paddingTop: theme.spacing.none,
                    paddingBottom: theme.spacing.none,
                    flex: 1,
                    color: theme.palette.white,
                    width: '100%',
                    overflowY: filterLoading && !loading ? "hidden" : "scroll",
                    backgroundImage: `url(${SportImagesDict.Matchboard[process.env.REACT_APP_SPORT as SupportedSports]})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    paddingInline: theme.spacing.xs,
                }}>



                   <Box sx={{
                       display: 'flex',
                       justifyContent: 'space-between',
                       paddingTop: theme.spacing.md
                   }}>
                       <StyledIconButton height={'100%'}
                                         onClick={()=>{
                                             setDrawerOpen(prev => !prev);}}
                       >
                           <MenuOpenIcon sx={{ color: theme.palette.lightGrey }} />
                       </StyledIconButton>

                       <MamOptions optionsAspectRatio={highlightAspectRatioOption} handleOpenCreateAggregation={handleOpenPopupAggregates} disableHighlightButton={clips.length > 0} handleCreateHighlight={handleCreateHighlight} handleDeselectClip={handleDeselectClip} handleDeleteClip={handleDeleteClip} handleChangeView={handleChangeView}/>
                   </Box>

         <StyledDrawerComponent open={drawerOpen} onClose={() => setDrawerOpen(false)} width="400px">
             <Filter
                 options={filterValues}
                 activeFilter={activeFilters}
                 setActiveFilter={handleActiveFilter}
                 autoCompleteTextValues={autoCompleteTextValues}
                 onAutoCompleteTextChange={onAutoCompleteTextChange}
             />
         </StyledDrawerComponent>





                    <Box sx={{ display: "flex" }}>
                        <CssBaseline />

                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                paddingTop: theme.spacing.md,
                                flexDirection: "column",
                                overflowY: "hidden",
                                width: drawerOpen? `calc(100% - ${drawerWidth}px)` : "100%",
                                //   transition: "margin 0.1s ease-in-out",
                                marginLeft: drawerOpen ? `${drawerWidth}px` : 0,
                            }}>

                            <ClipAggregatePopup  isOpen={openCreateAggregate} handleClose={()=>{setOpenCreateAggregate(false)}} errorMessage={errorMessage} handleErrorMessage={handleErrorMessage}/>

                            {clips.length > 0 && (
                                <Accordion
                                    sx={{
                                        backgroundColor: theme.palette.blue,
                                        '&.Mui-expanded': {
                                            backgroundColor: theme.palette.blue,
                                        },
                                        '&:first-of-type': {
                                            borderTopLeftRadius: `${theme.border.radius.md} !important`,
                                            borderTopRightRadius: `${theme.border.radius.md} !important`,
                                        },
                                        '&:last-of-type': {
                                            borderBottomLeftRadius: `${theme.border.radius.md} !important`,
                                            borderBottomRightRadius: `${theme.border.radius.md} !important`,
                                        },
                                        overflow: 'hidden', // Ensure border-radius is visible
                                        border: `2px solid ${theme.palette.white}`,

                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon sx={{color: theme.palette.white}}/>}
                                        aria-controls="draggable-list-content"
                                        id="draggable-list-header"
                                    >
                                        <Typography sx={{ color: theme.palette.white }}>Selected clips ({clips.length})</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box
                                            display={'flex'}
                                            flexDirection={'column'}
                                            sx={{maxHeight: 500, overflowY: 'auto'}}
                                        >
                                            <DraggableListComponent items={clips} setItems={setClipState} deleteClipDraggable={deleteSpecificClips} />
                                            {aspectRatio === "16:9" &&
                                                <Box padding={theme.spacing.sm}>
                                                    <OpenerCloserComponent
                                                        selectedCompetition={selectedCompetition}
                                                        setSelectedCompetition={setSelectedCompetition}
                                                        selectedOpener={selectedOpener}
                                                        selectedCloser={selectedCloser}
                                                        setSelectedOpener={setSelectedOpener}
                                                        setSelectedCloser={setSelectedCloser}
                                                        selectedItemsCompetitions={uniqueCompetitions}
                                                        multi_event={areMultiEvent}
                                                        isCollapseOpen={true}
                                                        dynamicCompetitions={false}/>
                                                </Box>
                                                }
                                            <AudioFadingCollapse
                                                fade={audioFading}
                                                fadeDuration={audioFadingDuration}
                                                fadeDurationStep={fadeDurationStep}
                                                maxFadeDuration={maxAudioFadeDuration}
                                                minFadeDuration={minAudioFadeDuration}
                                                onFadeChange={setAudioFading}
                                                onFadeDurationChange={(value) => setAudioFadingDuration(value)}
                                            />
                                        </Box>
                                    </AccordionDetails>

                                </Accordion>
                                )
                            }
                        </Box>
                    </Box>
                    {filterLoading && !loading && (
                        <Box
                            sx={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                width: drawerOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
                                height: "100%",
                                bgcolor: "rgba(0, 0, 0, 0.4)",  // adjust opacity/color as you like
                                zIndex: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <SpinnerBox text="Applying filters…" spinnerSize={40} height={'100%'}/>
                        </Box>
                    )}
                    <Box
                        sx={{
                            position: "relative",
                            width: drawerOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
                            height: "100%",
                            marginLeft: drawerOpen ? `${drawerWidth}px` : 0,
                        }}
                    >
                        <CssBaseline/>

                        {loading ? (
                            <SpinnerBox height="50vh" spinnerSize={50} />
                        ) : selectView === "cards" ? (
                            <CompetitionContainer
                                competition={competitions}
                                setCompetition={handleCompetiton}
                            />
                        ) : (
                            <MamTableV2
                                loading={tableLoading}
                                clipsPlatform={tabularData}
                                handlePage={handlePage}
                                page={page}
                            />
                        )}

                    </Box>
                </Box>
            </Box>
        </PageContainer>
    );
};

export default Mam;
